import { getStore } from '@/utils/dva'
import { PrePayNoticeCode } from '../noticeType'

/**
 * 需求下线
 * todo 五一之后删除无用代码
 */
const getIsCooperNoticeShow = () => {
    return false
}

/**
 * 投放对象
 * 合同版本免费版
 * 有白名单
 */
const getIsFreeContractNoticeShow = () => {
    const { isFreeContractVersion } = getStore().getState().user
    const FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST =
        getStore().getState()?.menu?.userMenuWhiteList?.FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST

    return isFreeContractVersion && FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST
}

/**
 * 预充值公告是否展示
 * 免费版优先级 》 寻合作
 */
export default () => {
    if (getIsFreeContractNoticeShow()) {
        return PrePayNoticeCode.freeVersion
    }
    if (getIsCooperNoticeShow()) {
        return PrePayNoticeCode.findCooper
    }

    return undefined
}
